import dynamic from 'next/dynamic';
import { RoomDetailsProps } from './RoomDetails.types';

export const RoomDetails = dynamic<RoomDetailsProps>(() => import('./RoomDetails').then(module => module.RoomDetails));
